import { Skeleton } from "./ui/skeleton";

const BunnyInfoItem = ({ label, value, isLoading, styling}) => (
    <div className={'bg-gray-100 p-3 rounded-md ' + styling}>
        {isLoading ? (
            <>
                <h3 className='font-medium text-md'>{label}</h3>
                <Skeleton className='w-64 h-4' />
            </>
        ) : (
            <>
                <h3 className='font-medium text-md'>{label}</h3>
                {value}
            </>
        )}
    </div>
);

export default BunnyInfoItem;